enum KeyNames {
  ENTER_KEY = 'Enter',
  SPACE_KEY = ' '
}

export default KeyNames
